import React from 'react';
import SecondaryNav from './SecondaryNav/SecondaryNav';

const SpeedToMarket = () => {
	return <SecondaryNav />;
};

export default SpeedToMarket;
